import { Clear } from "@mui/icons-material";
import {
  Button,
  CircularProgress,
  Dialog,
  DialogActions,
  DialogContent,
  DialogTitle,
  IconButton,
  TextField,
  Typography,
} from "@mui/material";
import React from "react";
import { dialogStyles } from "../../../../../Constants/dialogStyles";
import { inputStyles } from "../../../../../Constants/inputStyles";
import {
  primaryButtonStyles,
  textButtonStyles,
} from "../../../../../Constants/buttonStyles";

const CreateGroupDialog = ({
  open,
  onClose,
  groupName,
  groupNameError,
  onGroupNameChange,
  onCreateGroup,
  loadingCreateGroup,
}) => {
  return (
    <Dialog
      open={open}
      onClose={onClose}
      fullWidth
      maxWidth={"sm"}
      PaperProps={{ sx: dialogStyles.dialogRoot }}
    >
      <DialogTitle sx={dialogStyles.dialogTitle}>
        <IconButton onClick={onClose} sx={dialogStyles.dialogCloseIcon}>
          <Clear fontSize="small" />
        </IconButton>
        <Typography sx={dialogStyles.dialogTitleText}>
          Create New Group
        </Typography>
      </DialogTitle>
      <DialogContent dividers sx={dialogStyles.dialogContent}>
        <Typography variant="caption">Group Name</Typography>
        <TextField
          value={groupName}
          onChange={onGroupNameChange}
          fullWidth
          autoFocus
          sx={inputStyles.textField}
          variant="outlined"
          placeholder="Enter Group Name"
          error={groupNameError}
          helperText={
            groupNameError
              ? "Group name already exists. Please choose a different name."
              : ""
          }
        />
      </DialogContent>
      <DialogActions sx={dialogStyles.dialogActions}>
        <Button onClick={onClose} sx={textButtonStyles}>
          Cancel
        </Button>
        <Button
          onClick={onCreateGroup}
          sx={primaryButtonStyles}
          disabled={!groupName.trim() || groupNameError || loadingCreateGroup}
        >
          {loadingCreateGroup ? <CircularProgress size={18} /> : "Create"}
        </Button>
      </DialogActions>
    </Dialog>
  );
};

export default CreateGroupDialog;
